import ErrorCodeHelper from '@finsight/error-codes';
import { Dispatch } from 'redux';
import noop from 'lodash/noop';
import * as actionTypes from './actionTypes';
import SubscriptionsRepository from '@/finsight/infrastructure/repository/SubscriptionsRepository';
import { getMessage, getErrorMessage } from '@/Framework/Message/Mapper/getMessage';
import createAsyncRequest from '@/Framework/State/Redux/createAsyncRequest';
import { messageCodes } from '@/Framework/Message/messages';
import { AlertManager } from '@dealroadshow/uikit/core/components/Alert';
import createAction from '@/Framework/State/Redux/createAction';
import { setPageNotFound } from '@/finsight/application/actions/redirect/actions';
import {
  prepareSubscriptionsData,
  prepareSubscriptionsFormValues,
  preparePayload,
  prepareArticlePayload,
} from '@/finsight/application/actions/subscriptions/helpers';

export const getUserSubscriptions = () => (dispatch: Dispatch<any>, getState: () => any) => {
  const subscriptionsRepository: SubscriptionsRepository = getState().container.get(SubscriptionsRepository);

  return dispatch(createAsyncRequest({
    payload: {},
    method: subscriptionsRepository.getUserSubscriptionsBySSID,
    types: [
      actionTypes.INIT_SUBSCRIPTIONS_FORM,
      actionTypes.INIT_SUBSCRIPTIONS_FORM_SUCCESS,
      actionTypes.INIT_SUBSCRIPTIONS_FORM_ERROR,
    ],
    callbacks: {
      responseHandler: (response) => {
        const subscriptionsData = prepareSubscriptionsData(response);
        const subscriptionsFormValues = prepareSubscriptionsFormValues(response);
        return { subscriptionsData, subscriptionsFormValues };
      },
      onError: ({ error, dispatch }) => {
        if (error?.error?.code === ErrorCodeHelper.getCodeByName('SESSION_NO_TOKEN_OR_SSID_PROVIDED')) {
          dispatch(setPageNotFound(true));
          return;
        }
        AlertManager.error(getErrorMessage(error));
      },
    },
  }));
};

export const submitSubscriptionsForm = (formData) => async (dispatch, getState) => {
  const payload = {
    subscriptionIds: preparePayload(formData),
    ...prepareArticlePayload(formData),
  };

  const subscriptionsRepository = getState().container.get(SubscriptionsRepository);

  dispatch(createAsyncRequest(
    {
      payload,
      method: subscriptionsRepository.updateUserSubscriptionsBySSID,
      types: [
        actionTypes.SUBMIT_SUBSCRIPTIONS_FORM,
        actionTypes.SUBMIT_SUBSCRIPTIONS_FORM_SUCCESS,
        actionTypes.SUBMIT_SUBSCRIPTIONS_FORM_ERROR,
      ],
      callbacks: {
        onSuccess: ({ dispatch }) => {
          AlertManager.success(getMessage(messageCodes.FINSIGHT_SUBSCRIPTIONS_SAVE_PREFERENCES_SUCCESS));
          dispatch(getUserSubscriptions());
        },
      },
    },
  ));
};

export const resetSubscriptionsState = () => createAction(actionTypes.RESET_SUBSCRIPTIONS_STATE);

export const subscribeUserBySSID = (payload, types, onSuccess = noop) => (dispatch, getState) => {
  const subscriptionsRepository = getState().container.get(SubscriptionsRepository);

  return dispatch(createAsyncRequest({
    method: subscriptionsRepository.createUserSubscriptionBySSID,
    payload,
    types,
    callbacks: {
      onSuccess,
    },
  }));
};
